<template>
  <div style="overflow-y:hidden;overflow-x: hidden">
    <router-view />
<!--    头部-->

  </div>

</template>

<style>

</style>
<script>


  export default {
    name:"App",

  }
</script>